import store from '@/state/store';
import projectSlice from '@/state/project.slice';
import { handleError } from '@/actions/common';
import { saveImplicitProjectThumbnails } from '../client';

export default async (projectId: string) => {
  try {
    await saveImplicitProjectThumbnails(projectId, {
      models: null,
      origin: null,
      small: null,
      tiny: null
    });

    store.dispatch(projectSlice.actions.clearThumbnail(projectId));
  } catch (error) {
    handleError(error);
    throw error;
  }
};